import React, { createContext, useContext, useState, useEffect } from "react"
import { useSelector } from "react-redux"
import { ConfigProvider } from "antd"
import { sportsmanTheme } from "themes/sportsman"
import { sportswomanTheme } from "themes/sportswoman"
import { themes as themeNames } from "constants/theme"
import { getQueryParamRemove } from "utils/query-params"
import { useFavicon } from "hooks/useFavIcon"

const themes = {
  [themeNames.sportsman]: sportsmanTheme,
  [themeNames.sportswoman]: sportswomanTheme
}

const THEME_KEY = "DS-theme"

const ThemeContext = createContext()

export const AntdThemeProvider = ({ children }) => {
  let queryParamDsTheme = getQueryParamRemove("ds-theme")
  queryParamDsTheme = queryParamDsTheme === themeNames.sportsman || queryParamDsTheme === themeNames.sportswoman ? queryParamDsTheme : null

  const userThemeMode = useSelector((state) => state.user.adventure_mode)
  const storageThemeMode = localStorage.getItem(THEME_KEY)
  const defaultMode = queryParamDsTheme || userThemeMode || storageThemeMode || themeNames.sportsman
  const [adjustedTheme, setAdjustedTheme] = useState(null)
  const theme = adjustedTheme || defaultMode
  const bodyClassList = document.body.classList

  const updateFavicon = useFavicon(theme)

  useEffect(() => {
    const themeToRemove = theme === themeNames.sportsman ? themeNames.sportswoman : themeNames.sportsman
    if (bodyClassList.contains(`theme-${themeToRemove}`)) {
      bodyClassList.remove(`theme-${themeToRemove}`)
    }
    bodyClassList.add(`theme-${theme}`)
    updateFavicon(theme)
  }, [theme, bodyClassList, updateFavicon])

  const switchTheme = (newTheme) => {
    bodyClassList.remove(`theme-${theme}`)
    bodyClassList.add(`theme-${newTheme}`)
    setAdjustedTheme(newTheme)
    updateFavicon(newTheme)
  }

  const saveThemeToStorage = (theme) => {
    localStorage.setItem(THEME_KEY, theme)
  }

  useEffect(() => {
    if (queryParamDsTheme && queryParamDsTheme === defaultMode) {
      saveThemeToStorage(queryParamDsTheme)
    }
  }, [queryParamDsTheme, defaultMode])

  return (
    <ThemeContext.Provider
      value={{
        theme,
        isSportsman: theme === themeNames.sportsman,
        isSportswoman: theme === themeNames.sportswoman,
        switchTheme,
        saveThemeToStorage
      }}
    >
      <ConfigProvider theme={themes[theme]}>{children}</ConfigProvider>
    </ThemeContext.Provider>
  )
}

export const useTheme = () => useContext(ThemeContext)
